module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-10",
    attrs: {
      "id": "ambis-test-bundle-form"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard'
        },
        {
          text: 'Ambis Test',
          to: {
            path: '/ambis-test'
          },
        },
        {
          text: 'List Bundle Subtes',
          to: {
            path: '/ambis-test/list-bundle'
          },
        },
        {
          text: !_vm.$route.query.id ?
            'Tambah Bundle Subtes' :
            'Ubah Bundle Subtes',
        } ],
      "divider": "|"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("\n            " + _vm._s(!_vm.$route.query.id ? "Tambah Bundle Soal" : "Ubah Bundle Soal") + "\n        ")])]), _vm._v(" "), _c('div', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('v-form', {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('div', [_c('label', [_vm._v("\n                            Nama Bundle Subtes\n                            "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-text-field', {
    staticClass: "mt-1",
    attrs: {
      "placeholder": "Masukan nama bundle subtes",
      "outlined": "",
      "dense": "",
      "maxlength": "100",
      "rules": [
        function (v) { return !!v ||
        'Nama bundle subtes wajib diisi!'; } ],
      "required": ""
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('div', [_c('label', [_vm._v("\n                            Deskripsi Bundle\n                            "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-text-field', {
    staticClass: "mt-1",
    attrs: {
      "placeholder": "Masukan deskripsi subtes bundle",
      "outlined": "",
      "dense": "",
      "maxlength": "150",
      "rules": [
        function (v) { return !!v ||
        'Deskripsi bundle subtes wajib diisi!'; } ],
      "required": ""
    },
    model: {
      value: (_vm.form.description),
      callback: function($$v) {
        _vm.$set(_vm.form, "description", $$v)
      },
      expression: "form.description"
    }
  })], 1), _vm._v(" "), _c('div', [_c('label', [_vm._v("\n                            Mata Pelajaran\n                            "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-autocomplete', {
    staticClass: "mt-1",
    attrs: {
      "placeholder": "Pilih Mata Pelajaran",
      "outlined": "",
      "dense": "",
      "items": _vm.mapelList,
      "item-text": "nama",
      "item-value": "id"
    },
    on: {
      "change": function($event) {
        return _vm.mapelSelected($event)
      }
    },
    model: {
      value: (_vm.form.mapel),
      callback: function($$v) {
        _vm.$set(_vm.form, "mapel", $$v)
      },
      expression: "form.mapel"
    }
  })], 1), _vm._v(" "), _c('div', [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-text', [_c('div', {
    staticClass: "font-weight-600 blacknew--text"
  }, [_vm._v("\n                                    Perakitan Soal\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "lightgreynew--text mb-3"
  }, [_vm._v("\n                                    Rakit soal dengan mencari bab atau kode\n                                    soal melalui tombol di bawah\n                                ")]), _vm._v(" "), _c('app-assemblesubtest', {
    key: _vm.keyAssembler,
    attrs: {
      "pdisabled": _vm.subject,
      "subject": _vm.subject,
      "bundles": _vm.bundles
    },
    on: {
      "updated": function($event) {
        return _vm.detailsUpdated($event)
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-5",
    attrs: {
      "align": "right"
    }
  }, [_c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("\n                            Kembali\n                        ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "depressed": "",
      "color": "blew",
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.bundleProcess()
      }
    }
  }, [_vm._v("\n                            Simpan\n                        ")])], 1)])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec9a882a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/ambis_test/components/CreateBundle.vue
// module id = 1508
// module chunks = 1